export default __webpack_public_path__ + "static/media/35 awards.be36b10c.jpeg";